import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const api = axios.create({
    baseURL: API_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor para añadir token de autenticación
api.interceptors.request.use(
    async (config) => {
        // Si tienes un token de Firebase, añádelo aquí
        const token = localStorage.getItem('firebaseToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor para manejo de errores
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
            console.warn('⚠️ Backend no disponible. Usando modo offline.');
            // Podrías activar un flag de modo offline aquí
        }
        return Promise.reject(error);
    }
);

// Endpoints específicos
export const sensorApi = {
    getLatest: (deviceId) => api.get(`/sensors/${deviceId}/latest`),
    getHistory: (deviceId, limit = 100) =>
        api.get(`/sensors/${deviceId}/history?limit=${limit}`),
};

export const alertsApi = {
    getAll: (sector) => api.get(`/alerts${sector ? `?sector=${sector}` : ''}`),
    create: (data) => api.post('/alerts', data),
    acknowledge: (id) => api.post(`/alerts/${id}/acknowledge`),
};

export const authApi = {
    verifyToken: (token) => api.post('/auth/verify', { token }),
    getUsers: () => api.get('/auth/users'),
    syncUser: (user) => api.post('/auth/sync', {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
        providerId: user.providerData?.[0]?.providerId
    }),
    generateCode: (uid) => api.post('/auth/generate-code', { uid }),
    linkUser: (observerUid, code) => api.post('/auth/link-user', { observerUid, code }),
    getLinkedDevices: (uid) => api.get(`/auth/linked-devices/${uid}`),
    unlinkDevice: (uid, targetUid, type) => api.post('/auth/unlink-device', { uid, targetUid, type }),
};


// Attach sub-modules to main api object
api.sensors = sensorApi;
api.alerts = alertsApi;
api.auth = authApi;

export const auditApi = {
    getLogs: () => api.get('/audit'),
};
api.audit = auditApi;

export default api;
